import { render } from "./EditProfile.vue?vue&type=template&id=4df8e494&scoped=true"
import script from "./EditProfile.vue?vue&type=script&lang=js"
export * from "./EditProfile.vue?vue&type=script&lang=js"

import "./EditProfile.vue?vue&type=style&index=0&id=4df8e494&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df8e494"]])

export default __exports__